import { SDK_STREAM_TIMEOUT_MS } from '@repo/config';
import { postRawRequest } from '../../httpClient';
import type { IImportCollectionQuotesV1Params } from './import-collection-quotes-v1-request';

export async function importCollectionQuotesV1Api({
  collectionId,
  pageTitle,
  force,
}: IImportCollectionQuotesV1Params): Promise<Response> {
  return postRawRequest({
    path: `/sys/quotes/v1/collections/${collectionId}/import${force ? '?force=true' : ''}`,
    body: { pageTitle },
    options: { timeout: SDK_STREAM_TIMEOUT_MS },
  });
}
